import { useState } from 'react';
import { COLORS, MOODS, COPING_TOOLS, AFFIRMATIONS } from '../constants';
import { Button, Card } from './UI';

export default function MoodCheckIn({ child, onComplete, onSwitchKid }) {
  const [selectedMood, setSelectedMood] = useState(null);
  const [step, setStep] = useState("mood");
  const affirmation = AFFIRMATIONS[Math.floor(Math.random() * AFFIRMATIONS.length)];

  const handleMoodSelect = (mood) => {
    setSelectedMood(mood);
    if (mood.value <= 2) setStep("coping");
    else setTimeout(() => setStep("done"), 500);
  };

  return (
    <div style={{ minHeight: "100vh", background: `linear-gradient(160deg, ${selectedMood ? selectedMood.color + "22" : COLORS.accentLighter} 0%, ${COLORS.white} 70%)`, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, transition: "background 0.5s" }}>
      <div style={{ width: "100%", maxWidth: 420 }}>

        {step === "mood" && (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 56, marginBottom: 8 }}>{child.avatar || "🧒"}</div>
            <div style={{ fontFamily: "Fredoka One, sans-serif", fontSize: 30, color: COLORS.text, marginBottom: 8 }}>Hey {child.name}! 🌟</div>
            <div style={{ fontFamily: "Nunito, sans-serif", fontSize: 16, color: COLORS.textMuted, marginBottom: 32 }}>How are you feeling today?</div>
            <div style={{ display: "flex", justifyContent: "center", gap: 12, flexWrap: "wrap" }}>
              {MOODS.map(mood => (
                <button key={mood.value} onClick={() => handleMoodSelect(mood)} style={{
                  background: selectedMood?.value === mood.value ? mood.color + "33" : COLORS.white,
                  border: `3px solid ${selectedMood?.value === mood.value ? mood.color : COLORS.border}`,
                  borderRadius: 20, padding: "16px 12px", cursor: "pointer", transition: "all 0.2s",
                  transform: selectedMood?.value === mood.value ? "scale(1.12)" : "scale(1)",
                  minWidth: 72, boxShadow: selectedMood?.value === mood.value ? `0 6px 20px ${mood.color}44` : "none"
                }}>
                  <div style={{ fontSize: 36 }}>{mood.emoji}</div>
                  <div style={{ fontFamily: "Nunito, sans-serif", fontSize: 11, fontWeight: 700, color: COLORS.textMuted, marginTop: 6 }}>{mood.label}</div>
                </button>
              ))}
            </div>
            {onSwitchKid && (
              <div style={{ marginTop: 28 }}>
                <button onClick={onSwitchKid} style={{ background: "none", border: "none", color: COLORS.textMuted, fontFamily: "Nunito, sans-serif", fontSize: 13, fontWeight: 600, cursor: "pointer", textDecoration: "underline" }}>
                  Not {child.name}? Switch kid →
                </button>
              </div>
            )}
          </div>
        )}

        {step === "coping" && (
          <Card style={{ textAlign: "left", background: "#FFFBEB", border: `1px solid #FFD93D` }}>
            <div style={{ fontFamily: "Fredoka One, sans-serif", fontSize: 22, color: COLORS.text, marginBottom: 8 }}>It's okay to feel that way 💛</div>
            <div style={{ fontFamily: "Nunito, sans-serif", fontSize: 13, color: COLORS.textMuted, marginBottom: 20 }}>Would you like to try something to help?</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 20 }}>
              {COPING_TOOLS.map(tool => (
                <div key={tool.label} style={{ background: COLORS.white, border: `1px solid ${COLORS.border}`, borderRadius: 12, padding: 12, textAlign: "center" }}>
                  <div style={{ fontSize: 28, marginBottom: 6 }}>{tool.emoji}</div>
                  <div style={{ fontFamily: "Nunito, sans-serif", fontWeight: 800, fontSize: 13, color: COLORS.text }}>{tool.label}</div>
                  <div style={{ fontFamily: "Nunito, sans-serif", fontSize: 11, color: COLORS.textMuted, marginTop: 2 }}>{tool.desc}</div>
                </div>
              ))}
            </div>
            <Button onClick={() => setStep("done")} variant="kid" style={{ width: "100%" }}>I'm ready to start my day 💪</Button>
          </Card>
        )}

        {step === "done" && (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 80, marginBottom: 16 }}>🌟</div>
            <div style={{ fontFamily: "Fredoka One, sans-serif", fontSize: 28, color: COLORS.text, marginBottom: 12 }}>{affirmation}</div>
            <div style={{ fontFamily: "Nunito, sans-serif", fontSize: 15, color: COLORS.textMuted, marginBottom: 32 }}>Let's see what's on your list today!</div>
            <Button onClick={onComplete} variant="kid" size="lg" style={{ width: "100%" }}>Let's Go! 🚀</Button>
          </div>
        )}
      </div>
    </div>
  );
}
